module.exports = __webpack_public_path__ + "static/img/Shared.Images.hhs-cdc-logo.d5185ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Shared.Images.hhs-cdc-logo.png
// module id = ui8Z
// module chunks = 1